<template>
  <van-popup
    :class="[
      'wallet-pay-result',
      isDesktop ? 'desktop-layout' : isTurbo ? 'gt-layout' : 'mobile-layout',
      isNewClass,
    ]"
    round
    v-model="show"
    position="bottom"
    closeable
    :close-on-click-overlay="false"
  >
    <section>
      <!-- 余额不足 -->
      <div class="main-content flex-col-center">
        <p class="title">{{ $t('game.insufficient_balance') }}</p>
        <p class="desc flex-center">
          <span
            >{{ $t('wallet.account_balance') }}:
            {{ accountBalance | formatMoney }}</span
          >
          <img alt="" v-lazy="require(`@/assets/images/wallet/T-coin.png`)" />
        </p>
        <van-image
          width="150"
          height="150"
          lazy-load
          :src="
            require(`@/assets/images/common/result/insufficient-balance-new.png`)
          "
        />
        <p class="guide-tip flex-center">
          {{ $t('game.recharge_guide') }}
        </p>
      </div>
      <button class="footer-btn" @click="goto()">
        {{ $t('wallet.topup_right_now') }}
      </button>
    </section>
  </van-popup>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { getQueriesObject } from '@/utils/utils'
  import { urlAddNotNullParams } from '@/utils/url'
  import { tryToNative } from '@/utils/native'

  import {
    trackRechargePopupShow,
    trackRechargeWallet,
  } from '@/pages/Wallet/firebase'

  export default {
    name: 'wallet-pay-result',
    props: {
      accountBalance: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        show: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'isDesktop', 'isTurbo']),
      ...mapGetters(['isNewClass', 'appBaseUrl']),
    },
    watch: {
      show(val) {
        if (val) {
          trackRechargePopupShow({ page: this.gameName })
        }
      },
    },
    methods: {
      goto() {
        trackRechargeWallet({ page: this.gameName })
        // 退出充值结果页的时候千万不要带上第三方及服务端拼接的信息
        const queries = getQueriesObject([
          'source',
          'mode',
          'serverid',
          'country',
          'from',
        ])

        let url = urlAddNotNullParams(`${this.appBaseUrl}/myWallet`, {
          ...queries,
          from: this.gameName,
        })
        const params = JSON.stringify({
          title: this.$t('wallet.my_wallet'),
          requireLogin: true,
        })
        tryToNative({
          url,
          params,
        })
          .then(() => {})
          .catch(() => {
            this.$router_push({
              path: `/myWallet`,
              query: {
                ...queries,
                from: this.gameName,
              },
            })
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .wallet-pay-result {
    font-family: 'Manrope';
    padding: 72px 80px;
    box-sizing: border-box;
    height: 75%;
    .main-content {
      text-align: center;
      .title {
        font-weight: 800;
        font-size: 72px;
        line-height: 98px;
        margin: 90px 0 20px;
        color: rgba(249, 96, 0, 1);
      }
      .desc {
        font-weight: 600;
        font-size: 60px;
        line-height: 82px;
        margin-bottom: 10px;
        color: rgba(249, 96, 0, 1);
        & > span {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        & > img {
          width: 82px;
          height: 88px;
          object-fit: contain;
          margin-left: 22px;
        }
      }
      .van-image {
        margin: 50px 0;
      }
      .guide-tip {
        font-size: 30px;
        font-weight: 500;
        line-height: 41px;
        letter-spacing: 0em;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .wallet-pay-result.gt-layout {
    height: 1214px;
    .main-content {
      .title {
        margin: 50px 0 0;
      }
      .desc {
        margin-bottom: 0;
      }
      .van-image {
        margin: 0;
      }
    }
  }
  .wallet-pay-result.desktop-layout {
    font-family: 'Manrope';
    padding: 27.6px 30.7px;
    box-sizing: border-box;
    height: 75%;
    width: 414px;
    position: fixed;
    left: 50%;
    margin-left: -207px;
    .main-content {
      text-align: center;
      .van-image {
        margin: 18.5px 0;
      }
      .title {
        font-weight: 800;
        font-size: 23px;
        line-height: 31px;
        margin: 33.3px 0 11.5px;
      }
      .desc {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 3.7px;
        color: rgba(143, 134, 123, 1);
        & > img {
          width: 30.4px;
          height: 32.6px;
          object-fit: contain;
          margin-left: 8px;
        }
      }
      .guide-tip {
        font-size: 12px;
        font-weight: 500;
        line-height: 15.7px;
        letter-spacing: 0em;
        color: rgba(0, 0, 0, 0.6);
      }
    }
    .footer-btn {
      position: absolute;
      left: 32px;
      right: 32px;
      bottom: 27px;
      margin-top: 27.6px;
      width: calc(100%-64px);
      height: 57.5px;
      background: #ff5c1c;
      border-radius: 38.4px;
      font-weight: 800;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      text-transform: uppercase;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .wallet-pay-result.is-new {
    background: $gray-popup;
    .main-content {
      .title,
      .desc span {
        font: 600 48px/65px 'Noto Sans';
        color: $white;
      }

      .title {
        margin-bottom: 40px;
      }
      .desc img {
        width: 62px;
        height: 66px;
      }
      .guide-tip {
        font: 400 36px/49px 'Noto Sans';
        color: $white-5;
      }
    }

    .footer-btn {
      @include ok-btn();
    }
  }
</style>
